/**
 * Runtime configuration, the same mechanism as Kit19Sales (src/config/runtimeConfig.js).
 *
 * react-scripts inlines process.env.REACT_APP_* at build time, so a deployed build
 * cannot change hosts without a rebuild. public/config.js (loaded by index.html before
 * the bundle, editable on the server) overrides any of those keys at runtime. A key
 * that is missing or empty in window.__KIT19_ENTITY_CONFIG__ falls back to the
 * build-time .env value, so a build with an untouched config.js behaves as before.
 *
 * process.env.REACT_APP_* must be spelled out literally below: CRA only substitutes
 * exact member expressions.
 */
const BUILD_TIME: Record<string, string | undefined> = {
  REACT_APP_USE_MOCK: process.env.REACT_APP_USE_MOCK,
  REACT_APP_API_BASE_URL: process.env.REACT_APP_API_BASE_URL,
  REACT_APP_API_TOKEN: process.env.REACT_APP_API_TOKEN,
  REACT_APP_PARENT_ID: process.env.REACT_APP_PARENT_ID,
  REACT_APP_USER_ID: process.env.REACT_APP_USER_ID,
  REACT_APP_MODULE_CODE: process.env.REACT_APP_MODULE_CODE,
  REACT_APP_TIMEZONE: process.env.REACT_APP_TIMEZONE,
  REACT_APP_LEGACY_BASE_URL: process.env.REACT_APP_LEGACY_BASE_URL,
  REACT_APP_SSO_ENABLED: process.env.REACT_APP_SSO_ENABLED,
  REACT_APP_SSO_LOGIN_URL: process.env.REACT_APP_SSO_LOGIN_URL,
  REACT_APP_SSO_LOGOUT_URL: process.env.REACT_APP_SSO_LOGOUT_URL,
  REACT_APP_SSO_API_URL: process.env.REACT_APP_SSO_API_URL,
  REACT_APP_SSO_APP_NAME: process.env.REACT_APP_SSO_APP_NAME,
  // white-label fallbacks — the SSO session's Logo / FaviconIcon / CompanyName win when present
  REACT_APP_BRAND_NAME: process.env.REACT_APP_BRAND_NAME,
  REACT_APP_BRAND_LOGO_URL: process.env.REACT_APP_BRAND_LOGO_URL,
  REACT_APP_BRAND_FAVICON_URL: process.env.REACT_APP_BRAND_FAVICON_URL,
  REACT_APP_ROUTER_BASENAME: process.env.REACT_APP_ROUTER_BASENAME,
}

declare global {
  interface Window {
    __KIT19_ENTITY_CONFIG__?: Record<string, unknown>
  }
}

const runtime = (): Record<string, unknown> =>
  (typeof window !== 'undefined' && window.__KIT19_ENTITY_CONFIG__) || {}

/** Value for a REACT_APP_* key: runtime override if present and non-empty, else the build-time value. */
export const cfg = (key: string): string | undefined => {
  const rt = runtime()[key]
  if (rt !== undefined && rt !== null && String(rt) !== '') return String(rt)
  return BUILD_TIME[key]
}
